export default __webpack_public_path__ + "static/media/vsTech.dcb0a282.jpg";